<template>
  <div>
    <div class="event-properties-item">
      <div class="event-label">{{ title }}</div>
      <div>
        <el-input size="mini" v-model="target" @change="updateProp"></el-input>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "目标tag",
    },
    uuid: {
      type: String,
      default: "",
    },
    technology:{
      type:Object,
      default:{}
    },
  },
  data() {
    return {
      target: "",
    };
  },
  created(){
    this.event = this.technology.getEvent(this.uuid);
    this.target = this.event.value;
  },
  methods: {

    updateProp(e) {
      this.event.value = this.target;
    },
  },
};
</script>
<style lang="scss" scoped>
.event-properties-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .event-label {
    width: 120px;
  }
}
</style>